<template>
  <div id="contenedor-contrato-contratos-relacionados-main">
    <tool-bar
      v-if="!$apollo.loading"
      class="my-3"
      v-on:agregar-contrato-relacionado="agregarContratoRelacionado"
    >
    </tool-bar>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody"
    >
    </v-skeleton-loader>
    <listado
      v-if="!$apollo.loading"
      :listadoContratosRelacionados="getContratosRelacionados">
    </listado>
    <!-- Ventana Agregar Contrato Relacionado -->
    <v-dialog
      v-model="mostrarAgregarContratoRelacionado"
      width="600"
      persistent>
      <agregar-contrato-relacionado
        v-if="contrato && mostrarAgregarContratoRelacionado"
        :contrato="getContrato"
        :contratos="getContratos"
        :contratosRelacionados="getContratosRelacionados"
        v-on:cerrar="cerrarVentana">
      </agregar-contrato-relacionado>
    </v-dialog>
    <!-- Ventana Eliminar Contrato Relacionado -->
    <v-dialog
      v-if="esteContratoRelacionado"
      v-model="mostrarEliminarContratoRelacionado"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
      <eliminar-contrato-relacionado
        :contratoRelacionadoEliminar="esteContratoRelacionado"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratosParaRelacionar.gql';
import CONTRATO_RELACIONADOS from '@/graphql/querys/administracion/contratos/contratosRelacionados/contratoRelacionados.gql';
import AgregarContratoRelacionado from '@/components/administracion/contratos/contrato/contratosrelacionados/Agregar.vue';
import EliminarContratoRelacionado from '@/components/administracion/contratos/contrato/contratosrelacionados/Eliminar.vue';
import eventBus from '@/helpers/eventBus';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'ContratoContratosRelacionadosMain',
  components: {
    ToolBar,
    Listado,
    AgregarContratoRelacionado,
    EliminarContratoRelacionado,
  },
  data() {
    return {
      mostrarAgregarContratoRelacionado: false,
      mostrarEliminarContratoRelacionado: false,
      esteContratoRelacionado: null,
    };
  },
  methods: {
    agregarContratoRelacionado() {
      this.mostrarAgregarContratoRelacionado = true;
    },
    cerrarVentana() {
      this.mostrarAgregarContratoRelacionado = false;
      this.mostrarEliminarContratoRelacionado = false;
      this.esteContratoRelacionado = null;
    },
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratos: {
      query: CONTRATOS,
    },
    contratoRelacionados: {
      query: CONTRATO_RELACIONADOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getContratosRelacionados() {
      if (!this.contratoRelacionados) return [];
      return this.contratoRelacionados;
    },
    getContratos() {
      if (!this.contratos) return [];
      return this.contratos;
    },
  },
  mounted() {
    eventBus.$on('eliminar-contrato-relacionado', (contratoRelacionado) => {
      this.esteContratoRelacionado = contratoRelacionado;
      this.mostrarEliminarContratoRelacionado = true;
    });
  },
};
</script>

<style lang="scss">
</style>
